import { SortDirections } from '@/model/CommonModel';
import { MapStudioSortOptions } from '@/model/GraphicModel';
import { Button, Divider, Radio, RadioChangeEvent } from 'antd';
import React from 'react';
import styles from './graphicSortByContent.module.scss';

type Props = {
	sortField: MapStudioSortOptions;
	sortDirection: SortDirections;
	handleSortByOptionChanged: (e: RadioChangeEvent) => void;
	handleSortDirectionOptionChanged: (e: RadioChangeEvent) => void;
	onClearSortBy: () => void;
	onSortBy: () => void;
};

const GraphicSortByContent: React.FC<Props> = ({
	sortField,
	sortDirection,
	handleSortByOptionChanged,
	handleSortDirectionOptionChanged,
	onClearSortBy,
	onSortBy,
}) => {
	return (
		<div className={styles.container}>
			<Radio.Group value={sortField} onChange={handleSortByOptionChanged}>
				<div>
					<Radio value={MapStudioSortOptions.Name}>{_('Name')}</Radio>
				</div>
				<div>
					<Radio value={MapStudioSortOptions.LastUpdated}>{_('LastUpdated')}</Radio>
				</div>
			</Radio.Group>
			<Divider className={styles.divider} />
			<Radio.Group value={sortDirection} onChange={handleSortDirectionOptionChanged}>
				<div>
					<Radio value={SortDirections.Ascend}>{_('Ascend')}</Radio>
				</div>
				<div>
					<Radio value={SortDirections.Descend}>{_('Descend')}</Radio>
				</div>
			</Radio.Group>
			<Divider className={styles.divider} />
			<div className={styles.sortFooter}>
				<Button onClick={onClearSortBy}>{_('Reset')}</Button>
				<Button type='primary' onClick={onSortBy} disabled={false}>
					{_('Sort')}
				</Button>
			</div>
		</div>
	);
};

export { GraphicSortByContent };
